import React, { useEffect, useRef, useState } from "react";
import Loader from "../reusble_components/loader";
import CreditPoints from "../dashboard/creditPoints";
import { InterviewsCompleted } from "../dashboard/dashboard";
import { useStores } from "../../store";
import { Observer, useObserver } from "mobx-react";
import { uploadFileToAzure } from "../../services/azure";
import { toJS } from "mobx";
import { FiEdit } from "react-icons/fi";
import HelpCenter from "../reusble_components/helpCenter";
import { useNavigate } from "react-router-dom";
import ViewCredits from "../dashboard/viewCredits";
import ReferAndEarn from "../dashboard/ReferAndEarn";
import DeletePopup from "./DeletePopup";
import { apiPostPut } from "../../api/api_methods";

export default function RecruiterProf() {
  const [activeTab, setActiveTab] = useState(1);
  const { UserStore } = useStores();

  const [banner, setBanner] = useState(null);
  const [showTechFusionHeader, setShowTechFusionHeader] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const openGoogleForms = () => {
    window.location.href = banner.link;
  };
  const handleCloseTechFusionHeader = () => {
    setShowTechFusionHeader(false);
  };
  const getbanner = async () => {
    const userDetails = JSON.parse(localStorage.getItem("user"));
    const data = {
      clusterId: "65eeb0ff14b93e4c5bc91aef",
    };
    const response = await apiPostPut(
      data,
      "/admin/get-active-banner?usedFor=company",
      "POST"
    );
    if (response.status === 200) {
      console.log("response", response.body.data);
      console.log("response", response.body.data);
      if (response.body.data < 0) {
        setShowTechFusionHeader(false);
      }

      setBanner(response.body.data);
      setShowTechFusionHeader(true);
      setLoaded(true);
    } else {
      setShowTechFusionHeader(false);
    }
  };

  useEffect(() => {
    if (!loaded) {
      getbanner();
    }
  }, []);
  const [load, setLoad] = useState(false);
  return (
    <Observer>
      {() => (
        <>
          <HelpCenter />
          <Loader loader={load} />
          <div className="flex w-[95%] md:w-[100%] lg:w-[100%] mx-auto pt-24 md:pt-28   lg:pt-56  bg-image    ">
            <div className=" md:h-[80vh] lg:h-[90vh] h-[82vh] md:w-[90%] lg:w-[90%] w-[100%]  mx-auto bg-white  shadow-mds">
              <div className="flex justify-content space-x-20 pt-2 px-[6%] lg:text-3xl transition-all duration-500 ease-out">
                <button
                  onClick={() => setActiveTab(1)}
                  className={`transition-all duration-100 ease-in border-b-2 text-base h-10 w-48 md:h-16 md:w-36 lg:h-24 lg:w-52 ${
                    activeTab === 1
                      ? "border-primary text-black font-medium text-base lg:text-2xl"
                      : "border-transparent text-gray-400"
                  }`}
                >
                  Organization Info
                </button>
                <button
                  onClick={() => setActiveTab(2)}
                  className={`transition-all duration-100 ease-in border-b-2 text-base h-10 w-32 md:h-16 md:w-32 lg:h-24 lg:w-36 ${
                    activeTab === 2
                      ? "border-primary text-black font-medium text-base lg:text-2xl"
                      : "border-transparent text-gray-400"
                  }`}
                >
                  Credits
                </button>
              </div>
              {activeTab === 1 && <CompanyData />}
              {activeTab === 2 && <Credits />}
            </div>
          </div>
        </>
      )}
    </Observer>
  );
}

function CompanyData() {
  const [user, setUser] = useState({});
  const { UserStore } = useStores();
  const nameInputRef = useRef(null);
  const UsernameInputRef = useRef(null);
  const addressInputRef = useRef(null);
  const cityInputRef = useRef(null);
  const IndustryInputRef = useRef(null);
  const telephoneInputRef = useRef(null);
  const emailInputRef = useRef(null);
  const linkedInInputRef = useRef(null);
  const fileInputRef = useRef(null);

  const [isLoading, setIsLoading] = useState(false);

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const userGoogleDetails = JSON.parse(localStorage.getItem("user"));
  const [profile, setProfile] = useState(UserStore?.userDetails?.pic);

  useEffect(() => {
    const userDetail = localStorage.getItem("user");
    setUser(JSON.parse(userDetail));
    console.log(userDetail);
  }, []);

  useEffect(() => {
    if (UserStore?.userPic) {
      setProfile(UserStore?.userPic);
      console.log(profile, "1");
    } else if (user?.pic) {
      setProfile(user?.pic);
      console.log(profile, "4");
    } else {
      setProfile(userGoogleDetails?.picture);
      console.log(profile, "2");
    }
  }, [UserStore.userPic, user]);

  useEffect(() => {
    setProfile(UserStore?.userDetails?.pic);
    console.log(profile, "3");
  }, []);
  // const user = JSON.parse(localStorage.getItem("user"));
  // console.log(user.referalCode, "hgfhg");

  const defaultProfile =
    "https://static.vecteezy.com/system/resources/thumbnails/009/292/244/small/default-avatar-icon-of-social-media-user-vector.jpg";

  const autoFillRef = () => {
    nameInputRef.current.value = user?.companyName ?? "";
    UsernameInputRef.current.value = user?.name ?? "";
    addressInputRef.current.value = user?.address ?? "";
    cityInputRef.current.value = user?.city ?? "";
    IndustryInputRef.current.value = user?.industry ?? "";
    telephoneInputRef.current.value = user?.mobile ?? "";
    emailInputRef.current.value = user?.mail ?? "";
    linkedInInputRef.current.value = user?.linkedIn ?? "";
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    const name = nameInputRef.current.value;
    const address = addressInputRef.current.value;
    const city = cityInputRef.current.value;
    const industry = IndustryInputRef.current.value;
    const telephone = telephoneInputRef.current.value;
    const email = emailInputRef.current.value;
    const linkedIn = linkedInInputRef.current.value;
    const username = UsernameInputRef.current.value;
    console.log(name, address, city, industry, telephone, email, linkedIn);
    console.log(toJS(UserStore.userDetails));
    let body = {
      name: username,
      companyName: name,
      address: address,
      city: city,
      industry: industry,
      mobile: telephone,
      mail: email,
      linkedIn: linkedIn,
      pic: profile,
    };
    setIsLoading(true);
    await UserStore.updateUserDetailsToServer(body);
    alert("profile updated successfully");
    setIsLoading(false);
  };

  useEffect(() => {
    autoFillRef();
  }, [user]);

  return useObserver(() => (
    <>
      {<Loader loader={isLoading} />}
      <div className="md:w-[95%] relative lg:w-[95%] w-[100%] border-t mx-auto py-2 ">
        <div className="flex flex-row justify-between items-center">
          <p className="text-lg font-bold md:px-10 lg:px-10 px-8 pt-2 text-orange-500">
            Basic Details
          </p>
          <p className="text-gray-500 text-xs md:text-sm mr-[5%] lg:mr-[3.5%] pt-2">
            Profile ID: <span>{user?._id}</span>
          </p>
        </div>

        <form
          className="flex flex-col justify-center relative"
          onSubmit={submitHandler}
        >
          <div className="md:grid md:grid-cols-2 gap-4 md:p-6 lg:p-6 p-3 lg:text-xl">
            <div className="flex gap-5">
              <div className="relative">
                <input
                  type="file"
                  className="hidden"
                  ref={fileInputRef}
                  multiple={false}
                  accept=".png,.jpeg, .jpg"
                  onChange={async (e) => {
                    const timestamp = Date.now().toString();
                    const min = 1000;
                    const max = 9999;
                    const randomNumber =
                      Math.floor(Math.random() * (max - min + 1)) + min;
                    const filename = randomNumber + timestamp;
                    setIsLoading(true);
                    const fileUploaded = await uploadFileToAzure(
                      filename,
                      e.target.files[0],
                      { action: "profile" }
                    );

                    // console.log(fileUploaded.url);
                    const stringifiedURL = JSON.stringify(fileUploaded.url);
                    setProfile(fileUploaded.url);
                    UserStore.setUserPic(fileUploaded.url);
                    let body = { pic: fileUploaded.url };
                    // await UserStore.updateUserDetailsToServer(body).then(
                    //   (res) => {
                    //     console.log(res);
                    //   }
                    // );
                    setIsLoading(false);
                  }}
                />

                <div className="relative inline-block">
                  <img
                    src={profile || defaultProfile}
                    alt=" "
                    className="w-[80px] h-[80px] ml-[25%] lg:w-[150px] lg:h-[150px] border border-primary cursor-pointer rounded-full"
                    style={{
                      backgroundImage: `url(${defaultProfile})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                    onClick={handleButtonClick}
                  />

                  <button
                    onClick={handleButtonClick}
                    type="button"
                    className="absolute bottom-0 right-0 transform translate-x-2 translate-y-2 focus:outline-none"
                    style={{
                      background: "transparent",
                      border: "none",
                      cursor: "pointer",
                    }}
                  >
                    <span className="absolute right-0 -mt-5 lg:right-3 lg:-mt-8 transform -translate-x-2 -translate-y-2  bg-white rounded-full h-5 w-5 lg:h-7 lg:w-7 ">
                      <FiEdit className="h-2 w-[1.5rem] lg:h-4 lg:w-4 absolute top-[25%] right-0 lg:right-1" />
                    </span>
                  </button>
                </div>
              </div>
              <label
                className="mb-2 flex flex-col lg:pb-4 lg:p-3 mx-5"
                htmlFor="name"
              >
                <span className="lg:pb-2">Username</span>
                <input
                  type="text"
                  required
                  ref={UsernameInputRef}
                  onKeyDown={(event) => {
                    if (
                      !/^[a-zA-Z]$/.test(event.key) &&
                      event.key !== "Backspace" &&
                      event.key !== " "
                    ) {
                      event.preventDefault();
                    }
                  }}
                  className="border border-text_color5 p-3 mt-1 h-10 text-gray-500  lg:h-16 "
                />
              </label>
            </div>
            <label
              className="mb-2 flex flex-col lg:pb-4 lg:p-3 mx-5"
              htmlFor="name"
            >
              <span className="lg:pb-2">Name of the company</span>
              <input
                type="text"
                required
                ref={nameInputRef}
                className="border border-text_color5 p-3 mt-1 h-10 text-gray-500  lg:h-16 "
              />
            </label>
            <label
              className="mb-2 flex flex-col lg:pb-4 lg:p-3 mx-5"
              htmlFor="address"
            >
              <span className="lg:pb-2">Address of the company</span>
              <input
                type="text"
                required
                ref={addressInputRef}
                className="border  border-text_color5 p-3 mt-1 h-10 text-gray-500  lg:h-16"
              />
            </label>
            <label
              className="mb-2 flex flex-col lg:pb-4 lg:p-3 mx-5"
              htmlFor="city"
            >
              <span className="lg:pb-2">City</span>
              <input
                type="text"
                required
                ref={cityInputRef}
                className="border border-text_color5 p-3 mt-1 h-10 text-gray-500  lg:h-16"
              />
            </label>
            <label
              className="mb-2 flex flex-col lg:pb-4 lg:p-3 mx-5"
              htmlFor="industry"
            >
              <span className="lg:pb-2">Industry(IT/Marketing,etc)</span>
              <input
                type="text"
                required
                ref={IndustryInputRef}
                className="border border-text_color5 p-3 mt-1 h-10 text-gray-500  lg:h-16"
              />
            </label>
            <label
              className="mb-2 flex flex-col lg:pb-4 lg:p-3 mx-5"
              htmlFor="telephone"
            >
              <span className="lg:pb-2">Telephone Number</span>
              <input
                type="number"
                required
                ref={telephoneInputRef}
                className="border border-text_color5 p-3 mt-1 h-10 text-gray-500  lg:h-16"
              />
            </label>
            <label
              className="mb-2 flex flex-col lg:pb-4 lg:p-3 mx-5"
              htmlFor="mail"
            >
              <span className="lg:pb-2">Mail ID</span>
              <input
                type="text"
                required
                readOnly={true}
                ref={emailInputRef}
                className="border border-text_color5 p-3 mt-1 h-10 text-gray-500  lg:h-16 focus:outline-none "
              />
            </label>
            <label
              className="mb-2 flex flex-col lg:pb-4 lg:p-3 mx-5"
              htmlFor="linkedin"
            >
              <span className="lg:pb-2">LinkedIn</span>
              <input
                type="text"
                required
                ref={linkedInInputRef}
                className="border border-text_color5 p-3 mt-1 h-10 text-gray-500  lg:h-16"
              />
            </label>

            {/* <div className="flex w-[90%] mx-auto items-center md:ml-5 gap-2 md:mt-auto lg:mt-auto mt-5 mb-2">
          {profile ? (
            <>
              <img
                src={profile}
                style={{
                  backgroundImage: `url(${defaultProfile})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}

                alt=""
                className="w-10 h-10 object-cover rounded-[2.5rem]"
              />
            </>
          ) : (
              <div className="bg-secondary2  w-10 rounded h-10 text-center  text-text_color5 text-xl flex justify-center items-center">
              <IoPerson />
            </div>
          )}
            <input
              type="file"
              className="hidden"
              ref={fileInputRef}
              multiple={false}
              accept=".png,.jpeg, .jpg"
              onChange={async (e) => {

                const timestamp = Date.now().toString();
                const min = 1000;
                const max = 9999;
                const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
                const filename = randomNumber + timestamp;
                const fileUploaded = await uploadFileToAzure(filename, e.target.files[0], { action: "profile" });
        
                // console.log(fileUploaded.url);
                const stringifiedURL = JSON.stringify(fileUploaded.url);
                setProfile(fileUploaded.url);
                UserStore.setUserPic(fileUploaded.url);
                let body = { pic: fileUploaded.url };
                await UserStore.updateUserDetailsToServer(body).then((res) => {
                  console.log(res);
                });
        
              }}
            />
            <label
              onClick={handleButtonClick}
              className="md:px-10 lg:px-14 px-2 py-2  text-center flex justify-center items-center gap-2 lg:py-4  bg-primary text-white rounded-lg cursor-pointer hover:bg-[#e67f34] transition duration-300 ease-in-out"
            >
              <MdAddCircleOutline className="text-xl" />{" "}
                <span>Upload your photo</span>
            </label>
            <span className="text-sm md:text-base lg:text-base">(jpg/png format)</span>
          </div> */}
          </div>
          <div className="flex justify-between px-12 w-full">
            <p
              onClick={() => UserStore.setDeletePopup(true)}
              className="text-gray-400 text-center cursor-pointer md:w-[15%] lg:w-[15%] w-[40%] px-4 py-2 rounded-lg "
            >
              Delete Account
            </p>
            <button
              type="submit"
              className="text-white   bg-primary md:w-[15%] lg:w-[15%] w-[40%] px-4 py-2 rounded-lg "
            >
              {isLoading ? "Loading..." : "Update"}
            </button>
          </div>
        </form>
        {UserStore?.DeletePopup && <DeletePopup />}
      </div>
    </>
  ));
}

function Credits() {
  const [user, setUser] = useState({});
  const navigate = useNavigate();
  const { UserStore, PopupStore } = useStores();
  useEffect(() => {
    const userDetail = localStorage.getItem("user");
    setUser(JSON.parse(userDetail));
    console.log(userDetail);
  }, []);
  const [textToCopy, setTextToCopy] = useState(
    `https://app.reaidy.io?refer=${user?.referalCode}`
  );

  const handleCopyClick = () => {
    // Create a textarea element to temporarily hold the text
    const textarea = document.createElement("textarea");
    textarea.value = textToCopy;

    // Append the textarea to the document
    document.body.appendChild(textarea);

    // Select the text in the textarea and copy it to the clipboard
    textarea.select();
    document.execCommand("copy");

    // Remove the textarea from the document
    document.body.removeChild(textarea);
    alert("link copied !!!");
  };

  const [showCredits, setShowCredits] = useState(false);

  const handleButtonClick = () => {
    setShowCredits(!showCredits);
  };

  return (
    <>
      {PopupStore.referAndEarn && (
        <ReferAndEarn
          popUpInitialValue={PopupStore.referAndEarn}
          handlePopup={() => {
            PopupStore.setReferAndEarn(false);
          }}
        />
      )}
      <div className="mx-auto  flex flex-col  border-t md:w-[95%] lg:w-[95%] w-[100%]   overflow-hidden scrollbar-n mt-auto">
        {/* <div className="flex flex-col justify-center md:w-[90%] lg:w-[90%] w-[85%] mx-4  mt-4">
          <p className="text-primary font-semibold">Your Referral Code</p>
          <div className="flex items-center mt-2">
            <div
              className={`flex items-center justify-between pl-1 md:h-14 md:py-0 lg:py-0 p-2 border rounded-full md:w-[40%] lg:w-[40%] w-[95%] lg:h-20 `}
            >
              <p
                className={`flex placeholder-gray-300 items-center text-sm  md:text-base lg;text-base lg:text-2xl outline-none pl-4 text-black w-[80%] `}
              >
                <span> https://app.reaidy.io?refer={user?.referalCode}</span>
              </p>
              <MdOutlineCopyAll
                className={`text-2xl lg:text-3xl md:mr-5 lg:mr-5 mr-2 pr-[0%] lg:p-0 cursor-pointer 
                    `}
                onClick={handleCopyClick}
              />
            </div>
            <div className="border bg-primary rounded-full flex justify-center  text-white ml-[5%] ">
              <button
                className="flex justify-center text-lg items-center md:p-3 lg:p-3 p-2  md:px-5"
                onClick={() => {
                  PopupStore.setReferAndEarn(true);
                }}
              >
                <p className="pr-3 md:pr-2 font-medium"> share </p>

                <LuSend></LuSend>
              </button>
            </div>
          </div>
        </div> */}
        <div className="mx-4 flex flex-col md:flex-row lg:flex-row justify-center items-center my-2 md:w-[90%] lg:w-[90%] w-[85%]">
          <CreditPoints
            className="w-[50%] "
            availableCredits={user?.coins ?? 0}
          />

          <div className=" md:w-[100%] lg:w-[100%] w-full lg:mt-7 md:mt-7 ">
            <InterviewsCompleted className="w-full " />
          </div>
        </div>
        {/* {getMoreCreditsButton()} */}
      </div>
      <div className="px-2 md:px-4 lg:px-8">
        <ViewCredits availableCredits={user?.coins ?? 0} />
      </div>
      {/* <div className="ml-[6%]">
        <button className="ml-2 text-sm bg-primary rounded-lg text-white p-2"  onClick={handleButtonClick}>View Credits</button>
        {showCredits && <ViewCredits />}
      </div> */}
    </>
  );
}
